/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CustomerStatus
 */
export interface CustomerStatus {
    /**
     * 
     * @type {number}
     * @memberof CustomerStatus
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerStatus
     */
    categoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerStatus
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerStatus
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerStatus
     */
    color?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerStatus
     */
    order?: number;
}

/**
 * Check if a given object implements the CustomerStatus interface.
 */
export function instanceOfCustomerStatus(value: object): boolean {
    return true;
}

export function CustomerStatusFromJSON(json: any): CustomerStatus {
    return CustomerStatusFromJSONTyped(json, false);
}

export function CustomerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'name': json['name'] == null ? undefined : json['name'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'color': json['color'] == null ? undefined : json['color'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function CustomerStatusToJSON(value?: CustomerStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'categoryId': value['categoryId'],
        'name': value['name'],
        'icon': value['icon'],
        'color': value['color'],
        'order': value['order'],
    };
}

